import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';
import { cssVar } from 'styles/helper';

export const HubspotArticleEmailCaptureContainer = styled.div`
  display: flex;
  border-radius: 16px;
  flex-flow: row nowrap;
  overflow: hidden;
  min-height: 300px;
  background-color: ${palette.white};

  @media all and (max-width: 600px) {
    flex-flow: column nowrap;
  }
`;

export const HubspotArticleEmailCaptureLeftBackground = styled.div`
  flex: 0 1 36%;
  display: grid;
  position: relative;
  background: #409d9d;
  padding: 3rem 0rem;
`;

export const LeftBackgroundText = styled.div`
  z-index: 2;
  display: flex;
  row-gap: 1rem;
  align-self: center;
  align-items: center;
  position: relative;
  flex-flow: column wrap;

  & > h1 {
    line-height: 0.9em;
  }
`;

export const LeftBackgroundImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 0;
  mix-blend-mode: multiply;

  & > .texture-overlay {
    background-size: cover;
    z-index: 2;
  }
  & > .water-texture-overlay {
    background-size: cover;
    z-index: 1;
  }
`;

export const HubspotArticleEmailCaptureRightContent = styled.div`
  flex: 1 1 64%;
  padding: 2.5rem 3rem;

  @media all and (max-width: ${layout.sm}) {
    padding: 2.5rem 1.5rem;
  }
`;

export const HubspotArticleEmailTextContainer = styled.div`
  max-width: 332px;
  display: grid;
  row-gap: 1rem;

  & > a {
    padding: 12px 32px;
  }

  @media all and (max-width: 600px) {
    max-width: unset;
  }
`;

export const HubspotArticleEmailDescriptionText = styled.div`
  & > p.ast-p-element {
    line-height: 1.375em !important;
  }
`;

export const HubspotArticleEmailCtaText = styled.div`
  & > p.ast-p-element {
    font-size: 0.75rem !important;
    line-height: 1.375em !important;
  }
`;

export const HubspotFormWrapper = styled.div`
  form {
    & > :not(.hs_email) {
      display: none;
    }

    ul {
      display: none;
    }

    .hs_email {
      .hs-field-desc {
        font-size: 0.75rem;
        font-weight: 800;
      }
      input {
        height: 48px;
        padding: 1rem;
        font-size: 1.125rem;
        position: relative;
        border: 2px solid ${palette.greyText};
        width: 100%;
        margin: 0;
        outline: 0;
        color: #2d263b;
        border-radius: 4px;
        max-height: 58px;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        box-sizing: border-box;
        font-weight: 300;
        font-family: ${cssVar('font-family-body')};
      }
    }
  }
`;
